import { Button, Container, Flex, FormControl, FormLabel, Grid, Input } from "@chakra-ui/react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { postRequest, useMutationWrapper } from "services/apiHelper";
import { composersRequest } from "services/request";
import { successToast } from "utils/hooks";
import { Text } from "@chakra-ui/layout";
import { useSelector } from "react-redux";

const EditComposer = () => {
  const history = useNavigate();
  const { editComposer } = useSelector((state: any) => state.scripts);

  const [formData, setFormData] = useState({
    name: "",
    nickname: "",
    about: "",
    bio: "",
    dateofbirth: "",
    imageUrl: "",
    nationality: "",
    youtubeUrl: "",
    twitterUrl: "",
    instagramUrl: "",
    facebookUrl: "",
    websiteUrl: "",
    ...editComposer,
  });

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const onSuccess = () => {
    successToast("New composer has been created");
    history(-1);
  };
  const { mutate } = useMutationWrapper(postRequest, onSuccess);
  const handleSubmit = (e) => {
    e.preventDefault();
    mutate({
      url: composersRequest.COMPOSER,
      data: formData,
    });
  };
  return (
    <Flex flexDir="column" alignItems="center" justifyContent="center">
      <Container mt="4" maxW="container.xl">
        <Text px="4" textAlign="center" fontSize="15px" color="orangered">
          Note: You can only edit the composer name and nickname once!!!
        </Text>
        <Button
          variant="secondary"
          onClick={() => {
            history(-1);
          }}
        >
          Back
        </Button>

        <form onSubmit={handleSubmit}>
          <Grid
            templateColumns={{
              base: "repeat(1, 1fr)",
              lg: "repeat(2, 1fr)",
            }}
            gap={8}
          >
            <FormControl id="composerName" isRequired mb={4}>
              <FormLabel mb={1}>Composer Name</FormLabel>
              <Input
                type="text"
                _focus={{ boxShadow: "none" }}
                name="name"
                placeholder="Jude Nnam"
                value={formData.name}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="composerName" isRequired mb={4}>
              <FormLabel mb={1}>Nick Name</FormLabel>
              <Input
                type="text"
                _focus={{ boxShadow: "none" }}
                name="nickname"
                placeholder="Ansector"
                value={formData.nickname}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="composerName" mb={4}>
              <FormLabel mb={1}>About</FormLabel>
              <Input
                type="text"
                _focus={{ boxShadow: "none" }}
                name="about"
                placeholder="I am a composer"
                value={formData.about}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="composerName" mb={4}>
              <FormLabel mb={1}>Bio</FormLabel>
              <Input
                type="text"
                _focus={{ boxShadow: "none" }}
                name="bio"
                placeholder="lorem ipsum"
                value={formData.bio}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="composerName" mb={4}>
              <FormLabel mb={1}>Date Of Birth</FormLabel>
              <Input
                type="text"
                _focus={{ boxShadow: "none" }}
                name="dateofbirth"
                placeholder="12/12/1990"
                value={formData.dateofbirth}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="composerName" mb={4} isRequired>
              <FormLabel mb={1}>Nationality</FormLabel>
              <Input
                type="text"
                _focus={{ boxShadow: "none" }}
                name="nationality"
                placeholder="Nigerian"
                value={formData.nationality}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="composerName" mb={4}>
              <FormLabel mb={1}>Image</FormLabel>
              <Input
                type="text"
                _focus={{ boxShadow: "none" }}
                name="imageUrl"
                placeholder="https://www.google.com"
                value={formData.imageUrl}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="composerName" mb={4}>
              <FormLabel mb={1}>YouTube URL</FormLabel>
              <Input
                type="text"
                _focus={{ boxShadow: "none" }}
                name="youtubeUrl"
                placeholder="https://www.youtube.com"
                value={formData.youtubeUrl}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="composerName" mb={4}>
              <FormLabel mb={1}>Twitter URL</FormLabel>
              <Input
                type="text"
                _focus={{ boxShadow: "none" }}
                name="twitterUrl"
                placeholder="https://www.twitter.com"
                value={formData.twitterUrl}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="composerName" mb={4}>
              <FormLabel mb={1}>Instagram URL</FormLabel>
              <Input
                type="text"
                _focus={{ boxShadow: "none" }}
                name="twitterUrl"
                placeholder="https://www.instagram.com"
                value={formData.twitterUrl}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="composerName" mb={4}>
              <FormLabel mb={1}>Facebook URL</FormLabel>
              <Input
                type="text"
                _focus={{ boxShadow: "none" }}
                name="facebookUrl"
                placeholder="https://www.facebook.com"
                value={formData.facebookUrl}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl id="composerName" mb={4}>
              <FormLabel mb={1}>Website URL</FormLabel>
              <Input
                type="text"
                _focus={{ boxShadow: "none" }}
                name="websiteUrl"
                placeholder="https://www.mywebsite.com"
                value={formData.websiteUrl}
                onChange={handleChange}
              />
            </FormControl>
            <Button type="submit">Submit</Button>
          </Grid>
        </form>
      </Container>
    </Flex>
  );
};

export default EditComposer;
